<template>
  <div v-if="admin">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <a class="text-decoration--none" href="javascript:;">Admins</a>
        <v-icon> {{ icons.arrow }} </v-icon>
        <span v-if="form">{{ form.first_name }} {{ form.last_name }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-light mb-10">
        {{ form.first_name }} {{ form.last_name }}
      </div>
      <div class="d-flex flex-row align-stretch mb-12">
        <div>
          <v-avatar size="120" ref="userAvatar">
            <img
              :src="admin.avatar_thumb_url + '?ts=' + avatarTimestamp"
              alt="avatar"
            />
          </v-avatar>
        </div>
        <div class="d-flex flex-column justify-space-around ml-4">
          <v-btn
            text
            color="primary"
            @click="showCropperModal = !showCropperModal"
            :loading="avatarLoading"
          >
            <v-icon left>{{ icons.addImage }}</v-icon>
            Change Image
          </v-btn>
          <image-cropper v-model="showCropperModal" @change="avatarChange" />
        </div>
      </div>
      <v-form ref="form" v-if="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              outlined
              required
              v-model="form.first_name"
              label="First name"
              :error-messages="form.$getError('first_name')"
            ></v-text-field>

            <v-text-field
              required
              outlined
              v-model="form.last_name"
              label="Last name"
              :error-messages="form.$getError('last_name')"
            ></v-text-field>

            <v-text-field
              readonly
              outlined
              required
              v-model="form.email"
              label="E-mail"
              :error-messages="form.$getError('email')"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-btn
          color="primary"
          class="mr-4"
          @click="updateUserDetails"
          :loading="form.$busy"
        >
          Update
        </v-btn>
      </v-form>
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiChevronRight, mdiImagePlus } from '@mdi/js'
import { mapState } from 'vuex'
import ImageCropper from '@/components/modals/ImageCropper'
import Admin from '@/models/Admin'
import Form from '@/utils/form'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'AdminDetails',

  components: {
    ImageCropper,
    AppBarNavIcon
  },

  data() {
    return {
      admin: null,
      icons: {
        arrow: mdiChevronRight,
        addImage: mdiImagePlus
      },
      loading: false,
      avatarLoading: false,
      form: null,
      showCropperModal: false,
      avatarTimestamp: new Date().getTime(),
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  computed: {
    ...mapState({
      authUser: state => state.auth.user
    })
  },

  methods: {
    async getAdmin() {
      return Admin.$find(this.$route.params.id).then(admin => {
        this.form = new Form(admin)
        this.admin = admin
      })
    },

    changeAvatar(formData) {
      return this.$api.post(`${formData.get('user_id')}/avatar`, formData)
    },

    async avatarChange(image) {
      this.avatarLoading = true
      let data = new FormData()
      data.append('user_id', this.admin.id)
      data.append('avatar', image)
      await this.changeAvatar(data)
      this.avatarTimestamp = new Date().getTime()
      this.avatarLoading = false
      this.showSnackbar('Avatar successfully updated!')
    },

    async updateUserDetails() {
      this.form.$busy = true
      this.form.$clearErrors()
      const admin = new Admin(this.form.$data())
      admin
        .save()
        .then(() => {
          this.form.$busy = false
          this.showSnackbar('Details successfully updated!')
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    showSnackbar(message) {
      this.snackbar.message = message
      this.snackbar.show = true
    }
  },

  created() {
    this.getAdmin()
  },

  watch: {
    $route() {
      this.getAdmin()
    }
  }
}
</script>
